export default "__VITE_ASSET__82k$8Dby__"